var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip-group',_vm._l((_vm.modules),function(m){return _c('v-chip',{key:m.value,attrs:{"small":"","dark":_vm.dark,"color":m.color}},[_vm._v(" "+_vm._s(m.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }